"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unwrapRequestId = (request, response) => {
    if (response && response.headers.get("Argus-Request-ID")) {
        return response.headers.get("Argus-Request-ID");
    }
    if (request && request.headers.get("Argus-Request-ID")) {
        return request.headers.get("Argus-Request-ID");
    }
    return null;
};
exports.default = unwrapRequestId;
